import { messageErrorShow, messageSuccessShow } from 'Global/Stores/messages'

const globalMessageMiddleware = ({ dispatch, getState }) => next => action => {
  const { meta } = action

  if (!meta || (!meta.errorMessage && !meta.successMessage)) {
    return next(action)
  }

  if (action.meta.successMessage && action.type.startsWith('FULFILLED_API')) {
    dispatch(messageSuccessShow(action.meta.successMessage))
  }

  if (action.meta.errorMessage && action.type.startsWith('REJECTED_API')) {
    dispatch(messageErrorShow(action.meta.errorMessage))
  }

  return next(action)
}

export default globalMessageMiddleware
